import { Navigate, Route, Routes } from "react-router-dom";
import { NavigationRoutes } from "./NavigationRoutes";
// import useAuthStore from "../stores/authStore"; // Alpha mode: Auth disabled
import AppLayout from "../layout/AuthLayout/AuthLayout";

import {
  BookingDetails,
  Bookings,
  Dashboard,
  DisputeDetails,
  Disputes,
  Withdrawal,
  WithdrawalDetails,
  ProfileManagement,
  Reviews,
  UserDetails,
  UserManagement,
  VerificationRequests,
  VerificationDetailPage,
  ProductRequests,
  ProductRequestDetails,
} from "./LazyImports";

import useAuthStore from "@Store/authStore";
import { useEffect } from "react";

const authRoutes = [
  {
    title: "Dashboard",
    path: NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD,
    component: <Dashboard />,
  },
  {
    title: "OrderManagement",
    path: NavigationRoutes.DASHBOARD_ROUTES.USER_MANAGEMENT,
    component: <UserManagement />,
  },

  {
    title: "UserDetails",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.USER_DETAILS}/:id/:type`,
    component: <UserDetails />,
  },
  {
    title: "BookingsManagement",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.BOOKINGS_MANAGEMENT}`,
    component: <Bookings />,
  },
  {
    title: "BookingDetails",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.BOOKING_DETAILS}/:bookingId`,
    component: <BookingDetails />,
  },
  {
    title: "WithdrawalManagement",
    path: NavigationRoutes.DASHBOARD_ROUTES.WITHDRAWAL_MANAGEMENT,
    component: <Withdrawal />,
  },
  {
    title: "WithdrawalDetails",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.WITHDRAWAL_DETAILS}/:withdrawalId/:userId`,
    component: <WithdrawalDetails />,
  },
  {
    title: "DisputesManagement",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.DISPUTES_MANAGEMENT}`,
    component: <Disputes />,
  },
  // {
  //   title: "DisputeAction",
  //   path: `${NavigationRoutes.DASHBOARD_ROUTES.DISPUTE_ACTION}/:id`,
  //   component: <DisputeAction />,
  // },
  {
    title: "Profile",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.PROFILE_MANAGEMENT}`,
    component: <ProfileManagement />,
  },
  {
    title: "DisputeDetails",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.DISPUTE_DETAILS}/:id`,
    component: <DisputeDetails />,
  },

  {
    title: "ReviewsManagement",
    path: NavigationRoutes.DASHBOARD_ROUTES.REVIEWS_MANAGEMENT,
    component: <Reviews />,
  },
  {
    title: "VerificationManagement",
    path: NavigationRoutes.DASHBOARD_ROUTES.VERIFICATION_MANAGEMENT,
    component: <VerificationRequests />,
  },
  {
    title: "VerificationDetail",
    path: NavigationRoutes.DASHBOARD_ROUTES.VERIFICATION_DETAIL,
    component: <VerificationDetailPage />,
  },
  {
    title: "ProductRequestsManagement",
    path: NavigationRoutes.DASHBOARD_ROUTES.PRODUCT_REQUESTS_MANAGEMENT,
    component: <ProductRequests />,
  },
  {
    title: "ProductRequestDetails",
    path: `${NavigationRoutes.DASHBOARD_ROUTES.PRODUCT_REQUEST_DETAILS}/:id`,
    component: <ProductRequestDetails />,
  },
];
const Authenticated = () => {
  const { isAuth } = useAuthStore();
  const NAVIGATE_TO = isAuth
    ? NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD
    : NavigationRoutes.AUTH_ROUTES.LOGIN;

  useEffect(() => {
    document.title = "Dashbaord - Local Locker";
  }, []);

  return (
    <Routes>
      <Route element={<AppLayout />}>
        {authRoutes.map(({ path, component }, index) => {
          return <Route key={index} path={path} element={component} />;
        })}
      </Route>
      <Route path="*" element={<Navigate to={NAVIGATE_TO} />} />
    </Routes>
  );
};

export default Authenticated;
